import React from "react";
import { Search } from "lucide-react";

export function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
  size = "md",
  className = "",
  autoFocus = false,
  ...props
}) {
  const sizes = {
    sm: "py-2 pl-9 pr-3 text-sm",
    md: "py-3 pl-11 pr-4 text-sm",
    lg: "py-4 pl-12 pr-5 text-base",
  };
  return (
    <div className={`relative ${className}`}>
      <Search
        className={`text-zinc-500 absolute left-4 top-1/2 -translate-y-1/2 ${
          size === "sm" ? "w-3.5 h-3.5 left-3" : "w-4 h-4"
        }`}
        strokeWidth={1.75}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={`em-input ${sizes[size] || sizes.md}`}
        {...props}
      />
    </div>
  );
}

export default SearchInput;
